import { MutationTree } from "vuex";
import { IAuthState, IUser } from "@/store/modules/auth/types";
import { ApiCaller } from "@/ApiCaller";

type AuthMutationTree = MutationTree<IAuthState>;

export const mutations: AuthMutationTree = {
  setToken(state: IAuthState, accessToken: string) {
    state.accessToken = accessToken;
    ApiCaller.getInstance().configureHeaders(accessToken);
  },

  setLogged(state: IAuthState, isLogged: boolean) {
    state.isLogged = isLogged;
  },

  setUser(state: IAuthState, account: IUser) {
    state.account = account;
  },

  unsetToken(state: IAuthState) {
    state.accessToken = null;
  },

  setLogout(state: IAuthState) {
    state.accessToken = null;
    state.isLogged = false;
    state.account = null;
    ApiCaller.getInstance().configureHeaders(null);
  },

  setHomeRoomOn(state: IAuthState, payload: 0 | 1) {
    const { account } = state;

    if (account && account.permissions) {
      account.permissions.homeRoomOn = payload;
    }
  },

  complete(state: IAuthState) {
    state.isCompleted = true;
  },
};
